import { useState } from 'react'
import { ChevronRight, Loader2, CheckCircle2, XCircle } from 'lucide-react'
import { describeTool, bareName } from './toolDescriptors'

function formatValue(v) {
  if (v == null) return ''
  if (typeof v === 'string') return v
  try { return JSON.stringify(v, null, 2) }
  catch { return String(v) }
}

export function ToolUseCard({ tool }) {
  const [openInput, setOpenInput] = useState(false)
  const [openResult, setOpenResult] = useState(false)

  const status = !tool.result ? 'pending' : tool.result.isError ? 'error' : 'success'
  const StatusIcon = status === 'pending' ? Loader2 : status === 'error' ? XCircle : CheckCircle2

  const { icon: ToolIcon, text: label } = describeTool(tool.name, tool.input)

  return (
    <div
      className={
        'border rounded-lg my-2 text-xs '
        + (status === 'error'
          ? 'border-red-200 bg-red-50'
          : status === 'pending'
          ? 'border-gray-200 bg-gray-50'
          : 'border-emerald-200 bg-emerald-50/60')
      }
    >
      <div className="flex items-center gap-2 px-3 py-2" title={bareName(tool.name)}>
        <ToolIcon
          size={13}
          className={
            'flex-shrink-0 '
            + (status === 'error' ? 'text-red-400' : status === 'success' ? 'text-emerald-500' : 'text-gray-400')
          }
        />
        <span className="font-medium flex-1 truncate">{label}</span>
        <StatusIcon
          size={14}
          className={
            'flex-shrink-0 '
            + (status === 'pending'
              ? 'animate-spin text-gray-400'
              : status === 'error'
              ? 'text-red-500'
              : 'text-emerald-600')
          }
        />
      </div>

      {tool.input && Object.keys(tool.input).length > 0 && (
        <div className="border-t border-gray-200/60">
          <button
            type="button"
            onClick={() => setOpenInput(o => !o)}
            className="w-full flex items-center gap-1 px-3 py-1 text-[10px] text-gray-500 hover:bg-gray-100/60"
          >
            <ChevronRight size={10} className={'transition-transform ' + (openInput ? 'rotate-90' : '')} />
            Arguments
          </button>
          {openInput && (
            <pre className="px-3 py-2 text-[11px] font-mono whitespace-pre-wrap break-words bg-white/60 max-h-48 overflow-auto">
              {formatValue(tool.input)}
            </pre>
          )}
        </div>
      )}

      {tool.result && (
        <div className="border-t border-gray-200/60">
          <button
            type="button"
            onClick={() => setOpenResult(o => !o)}
            className="w-full flex items-center gap-1 px-3 py-1 text-[10px] text-gray-500 hover:bg-gray-100/60"
          >
            <ChevronRight size={10} className={'transition-transform ' + (openResult ? 'rotate-90' : '')} />
            Résultat {tool.result.isError ? '(erreur)' : ''}
          </button>
          {openResult && (
            <pre className="px-3 py-2 text-[11px] font-mono whitespace-pre-wrap break-words bg-white/60 max-h-64 overflow-auto">
              {tool.result.text}
            </pre>
          )}
        </div>
      )}
    </div>
  )
}
